export interface LoggerLikeInstance {
  info(...data: any[]): void;
  warn(...data: any[]): void;
  error(...data: any[]): void;
}

export type WithLogger<T> = T & {
  logger?: Logger;
};

const NOOP = () => undefined;

const noopLogger: LoggerLikeInstance = {
  info: NOOP,
  warn: NOOP,
  error: NOOP,
};

export class Logger {
  private prefix: string[];

  private logger: LoggerLikeInstance;

  constructor({
    logger,
    prefix,
  }: {
    logger: LoggerLikeInstance;
    prefix?: string[];
  }) {
    this.logger = logger;
    this.prefix = prefix ?? ['Logger'];
  }

  if(condition: boolean) {
    return condition ? this : new Logger({ logger: noopLogger });
  }

  info(...data: any[]) {
    this.logger.info(`[${this.prefix}]`, ...data);
  }

  warn(...data: any[]) {
    this.logger.warn(`[${this.prefix}]`, ...data);
  }

  error(...data: any[]) {
    this.logger.error(`[${this.prefix}]`, ...data);
  }
}

export default Logger;
